import { type ReactElement, useState } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';

import Textarea from '../../../../../components/Textarea/Textarea';
import { REJECT_REASON } from '../../../../../constants/formFields';
import {
  COMPANY_NAME_MIN_LENGTH, DEFAULT_MAX_LIMITED, DESCRIPTION_LENGTH, TYPE_OPTIONS,
} from '../../../../../constants/general';

import type { IMAIroQuestion } from '../../interfaces/IMAIroQuestions';
import type { IMAIroQuestionsReasonModal } from '../../interfaces/IMAIroQuestionsReasonModal';

import styles from '../../../MaterialAssessmentSurveyAnswer/scss/SurveyAnswerQuestion.module.scss';

function MAIROQuestionModal({
  control,
  open,
  onOpenReasonModal,
  questionIndex,
  setValue,
  question,
  handleHideThirdStep,
}: IMAIroQuestionsReasonModal): ReactElement {
  const { t } = useTranslation();
  const [disableButton, setDisableButton] = useState(false);

  const handleResetToActual = (questionItem: IMAIroQuestion): void => {
    const actualOption = questionItem.options.find(
      (option) => option.name?.toLowerCase() === TYPE_OPTIONS.ACTUAL
      || option.name?.toLowerCase() === TYPE_OPTIONS.POTENTIAL,
    );
    const optionToSelect = actualOption ?? questionItem.options[0];
    if (optionToSelect) {
      setValue(`questions.${questionIndex}.answer.selectedOptionId`, optionToSelect.id, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      setValue(`questions.${questionIndex}.answer.rejectReason`, '', {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });

      if (handleHideThirdStep && actualOption) {
        handleHideThirdStep(false);
      }
    }
    onOpenReasonModal(false);
  };

  return (
    <Modal
      open={open}
      title={t('materialityAssessment.reasonModalTitle')}
      description={t('materialityAssessment.reasonModalSubTitle')}
      confirmTitle={t('common.confirm')}
      closeTitle={t('common.cancel', 'Cancel')}
      confirmVariant={BUTTON_VARIANT.primary}
      onConfirm={() => onOpenReasonModal(false)}
      onReject={() => handleResetToActual(question)}
      onClose={() => handleResetToActual(question)}
      disabledConfirm={disableButton}
    >
      <Controller
        key={`questions.${questionIndex}.answer.rejectReason`}
        control={control}
        name={`questions.${questionIndex}.answer.rejectReason`}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          setDisableButton(!value || value.length < COMPANY_NAME_MIN_LENGTH || value.length > DEFAULT_MAX_LIMITED);
          return (
            <Textarea
              name={REJECT_REASON}
              value={value || ''}
              label={t('materialityAssessment.reason')}
              error={error?.message}
              className={styles.textField}
              placeholder={t('materialityAssessment.placeholder.enterYourAnswer')}
              charactersLimit={DESCRIPTION_LENGTH}
              onChange={(e) => onChange(e.target.value.slice(0, DESCRIPTION_LENGTH))}
            />
          );
        }}
      />
    </Modal>
  );
}

export default MAIROQuestionModal;
